import * as React from 'react';

export const AppleIcon: React.FC = () => {
  return (
    <svg width="18" height="23" viewBox="0 0 18 23" xmlns="http://www.w3.org/2000/svg">
      <title>7FBC6DD0-1FA5-4B78-A06D-135B6659144A</title>
      <path
        d="M13.399 0c-1.112.045-2.458.74-3.256 1.676-.715.826-1.342 2.15-1.172 3.419 1.24.096 2.506-.631 3.278-1.565.772-.934 1.293-2.234 1.15-3.53zM9.146 6.358c-.872 0-2.22-.988-3.647-.96-1.879.028-3.607 1.09-4.574 2.77-1.95 3.382-.497 8.393 1.4 11.137.93 1.342 2.036 2.853 3.49 2.797 1.402-.055 1.93-.905 3.622-.905 1.691 0 2.168.906 3.649.88 1.506-.03 2.462-1.372 3.384-2.718 1.065-1.557 1.505-3.064 1.53-3.144-.033-.014-2.937-1.126-2.968-4.471-.025-2.798 2.285-4.14 2.39-4.206-1.3-1.902-3.323-2.163-4.045-2.193a3.518 3.518 0 0 0-.401-.018c-1.57.022-3.026 1.03-3.83 1.03z"
        fill="currentColor"
        fillRule="evenodd"
        opacity=".9"
      />
    </svg>
  );
};
